var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueMyJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00711 1.30311L2.98311 3.55555H1.33333C0.979711 3.55555 0.640573 3.69603 0.390524 3.94608C0.140476 4.19613 0 4.53526 0 4.88889V6.56177L0.447111 6.78489C2.79221 7.95743 5.3781 8.56787 8 8.56787C10.6219 8.56787 13.2078 7.95743 15.5529 6.78489L16 6.56177V4.88889C16 4.53526 15.8595 4.19613 15.6095 3.94608C15.3594 3.69603 15.0203 3.55555 14.6667 3.55555H13.0169L11.9929 1.30311C11.8164 0.91458 11.5317 0.585086 11.173 0.354004C10.8142 0.122922 10.3965 2.5049e-05 9.96977 0H6.03022C5.60348 2.5049e-05 5.18577 0.122922 4.82701 0.354004C4.46825 0.585086 4.18361 0.91458 4.00711 1.30311ZM6.03022 1.77778C5.94492 1.7778 5.86143 1.80237 5.78972 1.84855C5.718 1.89473 5.66109 1.96058 5.62578 2.03822L4.936 3.55555H11.064L10.3742 2.03822C10.3389 1.96058 10.282 1.89473 10.2103 1.84855C10.1386 1.80237 10.0551 1.7778 9.96977 1.77778H6.03022Z",
    fill: "#73C7A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.54492C13.7707 9.60289 11.3537 10.2081 8.88889 10.3254V11.5556C8.88889 11.7913 8.79523 12.0174 8.62854 12.1841C8.46184 12.3508 8.23574 12.4445 8 12.4445C7.76425 12.4445 7.53816 12.3508 7.37146 12.1841C7.20476 12.0174 7.11111 11.7913 7.11111 11.5556V10.3254C4.67555 10.2089 2.25778 9.61603 0 8.54492V14.6667C0 15.0203 0.140476 15.3595 0.390524 15.6095C0.640573 15.8596 0.979711 16 1.33333 16H14.6667C15.0203 16 15.3594 15.8596 15.6095 15.6095C15.8595 15.3595 16 15.0203 16 14.6667V8.54492Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMyJobIcon);
export default __webpack_public_path__ + "static/media/blueMyJobIcon.9fae0860ccf84a9addc6c78653888beb.svg";
export { ForwardRef as ReactComponent };